import { extendTheme } from '@chakra-ui/react';
import { Styles } from '@chakra-ui/theme-tools';

import breakpoints from './foundations/breakpoints';
import colors from './foundations/colors';
import components from './foundations/components';
import fonts from './foundations/fonts';
import radius from './foundations/radius';
import shadows from './foundations/shadows';
import space from './foundations/space';

const styles: Styles = {
  global: () => ({
    'html, body, #root': {
      width: '100%',
    },

    body: {
      backgroundColor: 'var(--chakra-colors-appBg-primaryBg)',
    },

    '*': {
      boxSizing: 'border-box',
    },
  }),
};

export const theme = extendTheme({
  fonts,
  colors,
  breakpoints,
  space,
  styles,
  shadows,
  radii: radius,
  components,
});
